import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

export function TabTriggerRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const text = element.text
    ? String(resolveSymbol(element.text) ?? element.text)
    : ""

  // Check if this tab is selected by comparing with ui.selectedCategory
  const selectedCategory = resolveSymbol("#{ui.selectedCategory}")
  const isSelected = text === selectedCategory

  const handleClick = () => {
    if (element.events?.tap) {
      dispatchEvent(element.id, "tap", { value: text })
    }
  }

  return (
    <button
      role="tab"
      aria-selected={isSelected}
      onClick={handleClick}
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-all",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        isSelected
          ? "bg-background text-foreground shadow"
          : "text-muted-foreground hover:text-foreground",
        element.className,
      )}
    >
      {text}
    </button>
  )
}
